import Tips from "./Tips";

export default Tips;
